import React, { Component } from "react";
import MaterialTableComponent from "../../widgets/materialTable";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import adminService from "../../../Services/adminService";
import Swal from "sweetalert2";
import { Button, TextField } from "@material-ui/core";
import employeeServices from "../../../Services/employeeService";
import { Autocomplete } from "@material-ui/lab";
import countryList from "../../../assets/data/countriesList";
import config from "../../../config";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <>{children} </>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

class AgentsManager extends Component {
  state = {
    tab: 0,
    allowedDelete: false,
    agencyName: "",
    agencyId: "",
    agentsList: null,
    groupAgentsList: null,
    visasAffiliated: null,
    columns: [
      { title: "שם פרטי", field: "agentFirstName" },
      { title: "שם משפחה", field: "agentLastName" },
      {
        title: "סטטוס",
        field: "agentStatus",
        lookup: {
          active: "פעיל",
          suspended: "מושהה"
        }
      },
      { title: "מספר סוכן", field: "agentMobile" },
      { title: "מייל סוכן", field: "agentEmail" }
    ],
    fromAffiliateLinkGeneration: "",
    toAffiliateLinkGeneration: "",
    affiliateFromToLink: "",
    simpleAffiliateLink: ""
  };

  constructor(props) {
    super();
    this.redirectToAgentsGroups = (agentData, e) => {
      if (e.ctrlKey) window.open("/admin/agent-groups/" + agentData._id, "_blank");
      else this.props.history.push({ pathname: "/admin/agent-groups/" + agentData._id, state: agentData });
    };
    this.state.agencyName = props.match.params.agencyName;
    this.state.agencyId = props.match.params.agencyId;
    if (localStorage.getItem("role") === "admin" || localStorage.getItem("role") === "processor") this.state.allowedDelete = true;
  }

  componentDidMount() {
    const agencyId = this.props.match.params.agencyId;

    employeeServices.getAgents(agencyId).then((res) => {
      if (res["success"]) {
        const agentsList = res.agentsList.filter((agent) => !agent.agentType || agent.agentType.includes("reg"));
        const groupAgentsList = res.agentsList.filter((agent) => agent.agentType && agent.agentType.includes("group"));
        this.setState({ agentsList, groupAgentsList });
      }
    });
  }

  render() {
    return (
      <div className="container pb-70 rtl-layout right">
        <h2 className="yellow-color">
          שם סוכנות: <span className="black-color"> {this.state.agencyName}</span>
        </h2>

        <hr />
        <div>
          <h4 className="primary-color">
            <b>יצירת דוח</b>
          </h4>
          <div className="inline-block">
            תאריך תחילה
            <input onChange={this.reportDateChange} type="date" id="startDate" />
          </div>
          <div className="inline-block mr-30">
            תאריך סוף
            <input onChange={this.reportDateChange} type="date" id="endDate" />
          </div>
          <div className="inline-block mr-30">
            <Button onClick={this.downloadVouchers} color="primary" variant="contained" size="small">
              הורדת שוברים
            </Button>
          </div>
          <div className="inline-block mr-30">
            <Button onClick={this.createReport} color="secondary" variant="contained" size="small">
              דוח
            </Button>
          </div>
        </div>

        <div className="row mt-50">
          <div className="user-table-con col-sm-12">
            {!this.state.agentsList ? (
              <h4 className="primary-color">טוען מידע...</h4>
            ) : (
              <div className="relative">
                <div>
                  <Tabs
                    value={this.state.tab}
                    onChange={(_e, value) => {
                      this.setState({ tab: value });
                      if (value === 2) {
                        employeeServices.getAffiliatedVisaList(this.state.agencyId).then((res) => {
                          const visasAffiliated = res.visasAffiliated.map((x) => {
                            // Find the agent by affiliateId in the agents list
                            const agent = this.state.agentsList.find(agent => agent._id === x.affiliateId);
                            const groupAgent = this.state.groupAgentsList.find(agent => agent._id === x.affiliateId);
                            
                            let createdBy = "לא משויך"; // Default to agency
                            if (agent) {
                              createdBy = `${agent.agentFirstName} ${agent.agentLastName}`;
                            } else if (groupAgent) {
                              createdBy = `${groupAgent.agentFirstName} ${groupAgent.agentLastName}`;
                            }
                            
                            return {
                              ...x,
                              fullName: x.firstName + " " + x.lastName,
                              dateCreated: new Date(x.dateCreated).toLocaleDateString(),
                              createdBy
                            };
                          });
                          if (res["success"]) this.setState({ visasAffiliated });
                        });
                      }
                    }}
                  >
                    <Tab label="Agents" />
                    <Tab label="Group Agents" />
                    <Tab label="Affiliates" />
                  </Tabs>
                </div>
                {this.state.agentsList ? (
                  <>
                    <TabPanel value={this.state.tab} index={0}>
                      <MaterialTableComponent
                        agentType="reg"
                        options={{ pageSizeOptions: [5, 10, 20, 100] }}
                        data={this.state.agentsList}
                        columns={this.state.columns}
                        onDataChanged={this.handleDataChange}
                        tableTitle="טבלת סוכנים"
                        allowedDelete={this.state.allowedDelete}
                        performResendEmailConf={this.performResendEmailConf}
                        copyAffiliateId={this.copyAffiliateId}
                      />
                    </TabPanel>
                    <TabPanel value={this.state.tab} index={1}>
                      <MaterialTableComponent
                        agentType="group"
                        redirectToAgentsGroups={this.redirectToAgentsGroups}
                        options={{ pageSizeOptions: [5, 10, 20, 100] }}
                        data={this.state.groupAgentsList}
                        columns={this.state.columns}
                        onDataChanged={this.handleDataChange}
                        tableTitle="טבלת סוכני קבוצות"
                        allowedDelete={this.state.allowedDelete}
                        performResendEmailConf={this.performResendEmailConf}
                        copyAffiliateId={this.copyAffiliateId}
                      />
                    </TabPanel>
                    <TabPanel value={this.state.tab} index={2}>
                       <MaterialTableComponent
                        options={{ pageSizeOptions: [5, 10, 20, 100] }}
                        data={this.state.visasAffiliated || []}
                        columns={[
                          { title: "שם מלא", field: "fullName" }, //, editable: "onAdd"
                          { title: "מספר דרכון", field: "passportNum", editable: "never" },
                          { title: 'דוא"ל', field: "email", editable: "never" },
                          { title: "סוכן אפילייט", field: "createdBy" },
                          {
                            title: "סטטוס",
                            field: "status",
                            lookup: {
                              AGENT_PAID_AND_FILLS: "ממתין לטיפולך",
                              AGENT_PAID_CLIENT_FILLS: "ממתין לטיפול הלקוח שלך",
                              WAITING_PROCESSOR_PAID: "אנו מטפלים בבקשה",
                              WAITING_PROCESSOR_NOT_PAID: " אנו מטפלים בבקשה לא שולם",
                              WAITING_IN_OFFICE: "נמצא במשרד",
                              GOT_INTO_EMBASSY: "נכנס לקונסוליה",
                              WAITING_FOR_DOCUMENTS: "ממתינים למסמכים נוספים",
                              ACCES_GRANTED: "קיבל אשרה",
                              WITHOUT_TREATMENT: "ללא טיפול",
                              DENIED: "סירוב",
                              REFUND: "החזר כספית"
                            }
                          },
                          { title: "מוצא", field: "from" },
                          { title: "יעד", field: "to" },
                          { title: "נוצר ב", field: "dateCreated" }
                        ]}
                        tableTitle="טבלת ויזות מאפילייטים"
                      />
                      <div className="row mt-50">
                        {/* Simple Affiliate Link Section */}
                        <div className="col-md-6 mb-30">
                          <div className="card" style={{ 
                            border: '1px solid #e3e6f0', 
                            borderRadius: '8px', 
                            boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
                            height: '100%'
                          }}>
                            <div className="card-header" style={{ 
                              backgroundColor: '#f8f9fc', 
                              borderBottom: '1px solid #e3e6f0',
                              borderRadius: '8px 8px 0 0',
                              padding: '1rem 1.25rem'
                            }}>
                              <h6 className="m-0 font-weight-bold text-primary">
                                <i className="fas fa-link mr-2"></i>
                                לינק אפילייט פשוט
                              </h6>
                            </div>
                            <div className="card-body" style={{ padding: '1.5rem' }}>
                              <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                                לינק זה יוביל לעמוד הבית עם מזהה האפילייט
                              </p>
                              <button
                                onClick={() => {
                                  const simpleLink = `https://myvisae.com/?affiliateId=${this.state.agencyId}`;
                                  this.setState({ simpleAffiliateLink: simpleLink });
                                  navigator.clipboard.writeText(simpleLink).then(() => {
                                    Swal.fire("", "הלינק הועתק ללוח", "success");
                                  }).catch(() => {
                                    Swal.fire("", "שגיאה בהעתקת הלינק", "error");
                                  });
                                }}
                                className="btn btn-success btn-block"
                                style={{ 
                                  borderRadius: '6px',
                                  padding: '0.75rem 1rem',
                                  fontSize: '1rem',
                                  fontWeight: '500'
                                }}
                              >
                                <i className="fas fa-plus mr-2"></i>
                                יצר לינק אפילייט פשוט
                              </button>
                              
                              {this.state.simpleAffiliateLink && (
                                <div className="mt-4" style={{ 
                                  backgroundColor: '#f8f9fc', 
                                  border: '1px solid #e3e6f0', 
                                  borderRadius: '6px',
                                  padding: '1rem'
                                }}>
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <small className="text-muted font-weight-bold">לינק שנוצר:</small>
                                    <button
                                      onClick={() => {
                                        navigator.clipboard.writeText(this.state.simpleAffiliateLink).then(() => {
                                          Swal.fire("", "הלינק הועתק ללוח", "success");
                                        }).catch(() => {
                                          Swal.fire("", "שגיאה בהעתקת הלינק", "error");
                                        });
                                      }}
                                      className="btn btn-sm btn-outline-primary"
                                      style={{ 
                                        borderRadius: '4px',
                                        padding: '0.25rem 0.75rem',
                                        fontSize: '0.8rem'
                                      }}
                                    >
                                      <i className="fas fa-copy mr-1"></i>
                                      העתק
                                    </button>
                                  </div>
                                  <div style={{ 
                                    backgroundColor: 'white', 
                                    border: '1px solid #d1d3e2', 
                                    borderRadius: '4px',
                                    padding: '0.75rem',
                                    wordBreak: 'break-all',
                                    fontSize: '0.9rem',
                                    fontFamily: 'monospace'
                                  }}>
                                    {this.state.simpleAffiliateLink}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* From/To Affiliate Link Section */}
                        <div className="col-md-6 mb-30">
                          <div className="card" style={{ 
                            border: '1px solid #e3e6f0', 
                            borderRadius: '8px', 
                            boxShadow: '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)',
                            height: '100%'
                          }}>
                            <div className="card-header" style={{ 
                              backgroundColor: '#f8f9fc', 
                              borderBottom: '1px solid #e3e6f0',
                              borderRadius: '8px 8px 0 0',
                              padding: '1rem 1.25rem'
                            }}>
                              <h6 className="m-0 font-weight-bold text-primary">
                                <i className="fas fa-route mr-2"></i>
                                לינק אפילייט עם מוצא ויעד
                              </h6>
                            </div>
                            <div className="card-body" style={{ padding: '1.5rem' }}>
                              <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                                בחר מוצא ויעד ליצירת לינק ממוקד
                              </p>
                              
                              <div className="mb-3">
                                <Autocomplete
                                  options={countryList}
                                  style={{ width: '100%' }}
                                  renderInput={(params) => (
                                    <TextField 
                                      {...params} 
                                      label="מוצא" 
                                      variant="outlined" 
                                      size="small"
                                      style={{ marginBottom: '1rem' }}
                                    />
                                  )}
                                  onChange={(event, newInputValue) => {
                                    this.setState({
                                      fromAffiliateLinkGeneration: newInputValue
                                    });
                                  }}
                                />
                              </div>

                              <div className="mb-3">
                                <Autocomplete
                                  options={countryList}
                                  style={{ width: '100%' }}
                                  renderInput={(params) => (
                                    <TextField 
                                      {...params} 
                                      label="יעד" 
                                      variant="outlined" 
                                      size="small"
                                    />
                                  )}
                                  onChange={(event, newInputValue) => {
                                    this.setState({
                                      toAffiliateLinkGeneration: newInputValue
                                    });
                                  }}
                                />
                              </div>

                              <button
                                onClick={() => {
                                  if (!this.state.fromAffiliateLinkGeneration || !this.state.toAffiliateLinkGeneration) {
                                    this.setState({ affiliateFromToLink: "" });
                                    return Swal.fire("", "יש לבחור מוצא ויעד", "warning");
                                  }

                                  const to = this.state.toAffiliateLinkGeneration.toLowerCase();
                                  const from = this.state.fromAffiliateLinkGeneration.toLowerCase();

                                  const fromToLink = `https://myvisae.com/visa-type/${from}/${to}/?affiliateId=${this.state.agencyId}`;
                                  this.setState({ affiliateFromToLink: fromToLink });
                                  navigator.clipboard.writeText(fromToLink).then(() => {
                                    Swal.fire("", "הלינק הועתק ללוח", "success");
                                  }).catch(() => {
                                    Swal.fire("", "שגיאה בהעתקת הלינק", "error");
                                  });
                                }}
                                className="btn btn-primary btn-block"
                                style={{ 
                                  borderRadius: '6px',
                                  padding: '0.75rem 1rem',
                                  fontSize: '1rem',
                                  fontWeight: '500'
                                }}
                              >
                                <i className="fas fa-link mr-2"></i>
                                יצר לינק
                              </button>

                              {this.state.affiliateFromToLink && (
                                <div className="mt-4" style={{ 
                                  backgroundColor: '#f8f9fc', 
                                  border: '1px solid #e3e6f0', 
                                  borderRadius: '6px',
                                  padding: '1rem'
                                }}>
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <small className="text-muted font-weight-bold">לינק שנוצר:</small>
                                    <button
                                      onClick={() => {
                                        navigator.clipboard.writeText(this.state.affiliateFromToLink).then(() => {
                                          Swal.fire("", "הלינק הועתק ללוח", "success");
                                        }).catch(() => {
                                          Swal.fire("", "שגיאה בהעתקת הלינק", "error");
                                        });
                                      }}
                                      className="btn btn-sm btn-outline-primary"
                                      style={{ 
                                        borderRadius: '4px',
                                        padding: '0.25rem 0.75rem',
                                        fontSize: '0.8rem'
                                      }}
                                    >
                                      <i className="fas fa-copy mr-1"></i>
                                      העתק
                                    </button>
                                  </div>
                                  <div style={{ 
                                    backgroundColor: 'white', 
                                    border: '1px solid #d1d3e2', 
                                    borderRadius: '4px',
                                    padding: '0.75rem',
                                    wordBreak: 'break-all',
                                    fontSize: '0.9rem',
                                    fontFamily: 'monospace'
                                  }}>
                                    {this.state.affiliateFromToLink}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                     
                    </TabPanel>
                  </>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  reportDateChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  performResendEmailConf = (currentAgent) => {
    adminService.performResendEmailConf(currentAgent.agentEmail).then((res) => {
      if (res.success) {
        Swal.fire("", "מייל עם איפוס סיסמה נשלח בהצלחה", "success");
      }
    });
  };

  copyAffiliateId = (agentData) => {
    const affiliateUrl = `https://myvisae.com/?affiliateId=${agentData._id}`;
    navigator.clipboard.writeText(affiliateUrl).then(() => {
      Swal.fire("", "לינק האפילייט הועתק ללוח", "success");
    }).catch(() => {
      Swal.fire("", "שגיאה בהעתקת לינק האפילייט", "error");
    });
  };

  createReport = () => {
    var state = this.state;
    if (!state.endDate || !state.startDate) {
      return Swal.fire("", "יש להכניס תאריך התחלה ותאריך סיום", "warning");
    }
    if (state.startDate < "2005-01-01") {
      return Swal.fire("", "יש להכניס תאריך התחלה החל מ- 01-01-2005", "warning");
    }
    var data = { agencyId: state.agencyId, startDate: state.startDate, endDate: state.endDate };
    adminService.getAgencyReport(data).then((res) => {
      if (res["success"]) {
        const reportName = "Report " + state.startDate + " ~ " + state.endDate;
        if (!res.reportFormatArr || !res.reportFormatArr.length) {
          return Swal.fire("לא קיים מידע", "לא קיים מידע עבור הסוכנות המבוקשת בזמן שנבחר", "info");
        }

        adminService.exportExcelClientSide(res["reportFormatArr"], null, false, reportName);
      }
    });
  };

  downloadVouchers = () => {
    var state = this.state;
    if (!state.endDate || !state.startDate) {
      Swal.fire("", "יש להכניס תאריך התחלה ותאריך סיום", "warning");
      return;
    }
    var data = { agencyId: state.agencyId, startDate: state.startDate, endDate: state.endDate };
    adminService.getAgencyVouchers(data).then((res) => {});
  };

  handleDataChange = (dataToModify, action, agentType) => {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: "האם אתה בטוח?",
        text: "אתה הולך לעשות את הפעולה הבאה על המשתמש: " + action,
        icon: "warning",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          adminService.handleAgentChanges(dataToModify, action, this.state.agencyId, agentType).then((res) => {
            if (res["success"]) {
              if (res["newId"]) resolve(res["newId"]);
              else resolve();
              Swal.fire(`${action} - בוצע`, "", "success");
            } else {
              if (res["isExistingUser"]) {
                Swal.fire(`${action} - לא בוצע`, "קיים כבר משתמש", "warning");
              }
              reject();
            }
          });
        } else {
          reject();
        }
      });
    });
  };
}

export default AgentsManager;
